import axios from "axios";
import { i18n } from "../i18n";
// create an axios instance
const service = axios.create({
  baseURL: "/api", // process.env.BASE_API,
  timeout: 30000, // request timeout
});

// request interceptor language
service.interceptors.request.use((config) => {
  config.params = config.params || {};
  config.params.lang = i18n.locale;
  return config;
});

// respone interceptor
service.interceptors.response.use(
  (response) => {
    /**
     * The following comments indicate the request status by using the response custom code. When the code returns the following conditions, it is a problem with the permission. Log out and return to the login page.
     *
     * If the logic is identified by the xmlhttprequest status code, the logic can be written in the following error
     */
    return response;
  },
  (error) => {
    console.debug("Response error", error.message, error.response); // for debug
    return Promise.reject(error);
  }
);

export default service;
